module.exports = __webpack_public_path__ + "app/components/devices/tracker/history/all.view.html";